// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-container {\n  overflow: auto;\n}\n.tab {\n  box-shadow: 3px 5px 22px rgba(0, 0, 0, 0.03);\n  border-radius: 5px;\n  background-color: #fff;\n  text-align: left;\n  padding: 0 16px;\n}", ""]);
// Exports
module.exports = exports;
